import React, { type ReactNode } from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import Spinner from '@atlaskit/spinner/spinner';

import { LoadingContent } from '../loading-content';

const spinnerContainerStyles = xcss({
	display: 'flex',
	minWidth: '160px',
	padding: 'space.250',
	justifyContent: 'center',
});

export function Loading({ loadingText }: { loadingText?: ReactNode }): React.JSX.Element {
	if (fg('platform_dst-accessible-popup-loading')) {
		return (
			<Box xcss={spinnerContainerStyles}>
				<LoadingContent loadingText={loadingText ?? 'Loading popup...'} size="small" />
			</Box>
		);
	}

	return <Spinner />;
}
